module.exports = __webpack_public_path__ + "static/img/6.5832486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/6.png
// module id = VZ2T
// module chunks = 0